import {IFilters} from "../store/reducers/TransactionsSlice/TransactionsSlice";

export const prepareTransferPaginationData = (tempData: Partial<IFilters>, page: number) => {

    return {
        page: page,
        from: tempData.from,
        to: tempData.to,
        amount : tempData.amount,
        recipient: tempData.recipient,
        accountNumber : tempData.hiddenAccountNumber === "All" ? "" : tempData.hiddenAccountNumber,
        incoming: tempData.incoming,
        outgoing: tempData.outgoing,
        fees: tempData.fees,
        // other: tempData.other
    }
}
